import { TTransaction } from 'structure/bridge/store/transactionsAtom';
import { BridgeTransactionInFlight } from './BridgeTransactionInFlight';
import { MessageStatus } from '@layerzerolabs/scan-client';
import { BridgeTransaction } from './BridgeTransaction';
import { Address } from 'viem';
import { useState } from 'react';

interface Props {
  transactions: TTransaction[];
  user: Address;
}

export function BridgeTransactions({ transactions, user }: Props) {
  const [showAll, setShowAll] = useState(false);

  const userTransactions = transactions.filter((tx) => tx.userAddress === user);

  return userTransactions.length > 0 ? (
    <div className='mt-4 flex flex-col gap-2'>
      <h1 className='text-white'>Bridge transactions</h1>
      {userTransactions.reverse().map(
        (tx, index) =>
          (index < 3 ||
            tx.status === MessageStatus.INFLIGHT ||
            tx.failedMessage?._nonce ||
            showAll) && (
            <div key={tx.srcTxHash} className=''>
              {tx.status !== MessageStatus.DELIVERED ? (
                <BridgeTransactionInFlight // this component listens for the tx status
                  transaction={tx}
                />
              ) : (
                <BridgeTransaction // this component does NOT listen for the tx status to avoid overloading the rpc and endpoints
                  transaction={tx}
                />
              )}
              <div className='mt-2 border-b border-white' />
            </div>
          )
      )}
      {userTransactions.length > 3 && (
        <div className='items flex justify-center text-xs text-white'>
          <button className='flex' onClick={() => setShowAll((prev) => !prev)}>
            show all
            {!showAll ? (
              <svg
                className='ml-1 h-4 w-4'
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
              >
                <path
                  stroke='currentColor'
                  strokeLinecap='round'
                  stroke-linejoin='round'
                  stroke-width='2'
                  d='M19 9l-7 7-7-7'
                />
              </svg>
            ) : (
              <svg
                className='ml-1 h-4 w-4'
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
              >
                <path
                  stroke='currentColor'
                  strokeLinecap='round'
                  stroke-linejoin='round'
                  stroke-width='2'
                  d='M5 15l7-7 7 7'
                />
              </svg>
            )}
          </button>
        </div>
      )}
    </div>
  ) : null;
}

export default BridgeTransactions;
